class PasswordModal extends DetailsModal {
  constructor() {
    super();

    if (this.querySelector('input[aria-invalid="true"]')) this.open({ target: this.querySelector('details') });

    this.querySelectorAll('[data-password-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const field = button.closest('.password-field');
        const input = field?.querySelector('input[name="password"]');
        if (!input) return;

        const showPassword = input.type === 'password';
        input.type = showPassword ? 'text' : 'password';
        button.setAttribute('aria-pressed', showPassword ? 'true' : 'false');
        button.setAttribute('aria-label', showPassword ? 'Hide password' : 'Show password');
        field.classList.toggle('password-field--visible', showPassword);

        button.querySelector('.password-field__toggle-icon--show')?.classList.toggle('hidden', showPassword);
        button.querySelector('.password-field__toggle-icon--hide')?.classList.toggle('hidden', !showPassword);
      });
    });
  }
}

customElements.define('password-modal', PasswordModal);
